import React from 'react';
import clsx from 'clsx';

import styles from '../styles.module.scss';
import supportStyles from './Support.module.scss';
import {Support} from '../../../assets';

export const SupportCard = () => {
  return (
    <div className={supportStyles.support}>
      <div className={clsx(styles.label, styles.support)}>
        <div className={clsx(styles.labelInner, styles.support)}>support</div>
      </div>
      <h4 className={styles.title}>24/7 Technical Support</h4>
      <p className={styles.subTitle}>
        Our technicians is here to assist you anytime, day or night, ensuring everything runs
        smoothly.
      </p>
      <div className={supportStyles.infoWrapper}>
        <Support />
      </div>
    </div>
  );
};
